import { render, staticRenderFns } from "./PayrollChangeRequestDetailPage.vue?vue&type=template&id=6b6514f3&"
import script from "./PayrollChangeRequestDetailPage.vue?vue&type=script&lang=ts&"
export * from "./PayrollChangeRequestDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./PayrollChangeRequestDetailPage.vue?vue&type=style&index=0&id=6b6514f3&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports